/* eslint-disable no-unused-expressions */
const closeModal = (props) => {
   props?.onClose && props?.onClose();
}

export default closeModal;
